import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export interface SegmentResponse {
  pricing_and_distribution: Record<string, number[]>;
  deletion: Record<string, number[]>;
  addition: Record<string, number[]>;
}

export const fetchSegmentData = async (payload: any) => {
  return fetchData<SegmentResponse>(API_ENDPOINTS.SCENARIO_INPUT.INPUT_FILTERS, payload);
};

export const fetchStateWithPackSegmentData = async (payload: any) => {
  return fetchData<any>(API_ENDPOINTS.SCENARIO_INPUT.STATES_WITH_AVAILABLE_PACK_SEGMENTS, payload);
};

export const fetchSkuSizeReplacementPacksAPI = async (payload: any) => {
  return fetchData<any>(API_ENDPOINTS.SCENARIO_INPUT.SKU_SIZE_REPLACEMENT_FILTER, payload);
};
